import React from 'react';
import { X, Check } from 'lucide-react';
import { Card } from './ui/card';
import { Badge } from './ui/badge';

const ComparisonTable = () => {
  const comparisons = [
    {
      aspect: 'Zeitaufwand',
      diy: { value: '1-2 Stunden pro Tag', negative: true },
      with2besales: { value: '30 Minuten pro Monat', positive: true }
    },
    {
      aspect: 'Qualitätskontrolle',
      diy: { value: 'Keine Überprüfung', negative: true },
      with2besales: { value: 'Experten prüfen jede Nachricht', positive: true }
    },
    {
      aspect: 'Rückmelderate',
      diy: { value: 'Unter 20%', negative: true },
      with2besales: { value: 'Über 60%', positive: true }
    },
    {
      aspect: 'Skalierbarkeit',
      diy: { value: '5-10 Nachrichten/Tag', negative: true },
      with2besales: { value: '500-1.000 Interaktionen', positive: true }
    },
    {
      aspect: 'Setup & Training',
      diy: { value: 'Selbst lernen & einrichten', negative: true },
      with2besales: { value: 'Agentur übernimmt alles', positive: true }
    }
  ];

  return (
    <section className="py-24 px-6 bg-slate-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16 space-y-4">
          <Badge className="bg-blue-100 text-blue-700">Der Unterschied</Badge>
          <h2 className="text-4xl font-bold text-slate-900">
            Selbst machen vs. Done-for-you Agentur-Service
          </h2>
          <p className="text-xl text-slate-600">
            Warum täglich Stunden investieren? Wir übernehmen das komplett für dich.
          </p>
        </div>

        <Card className="overflow-hidden shadow-2xl border-2">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b-2 border-slate-200">
                  <th className="p-6 text-left text-slate-900 font-semibold text-lg bg-white">
                    Kriterium
                  </th>
                  <th className="p-6 text-center bg-red-50 text-slate-900 font-semibold text-lg">
                    <div className="flex items-center justify-center gap-2">
                      <X className="w-5 h-5 text-red-500" />
                      Selbst managen
                    </div>
                  </th>
                  <th className="p-6 text-center bg-green-50 text-slate-900 font-semibold text-lg">
                    <div className="flex items-center justify-center gap-2">
                      <Check className="w-5 h-5 text-green-500" />
                      Mit 2besales Agentur
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {comparisons.map((item, idx) => (
                  <tr key={idx} className="border-b border-slate-200 hover:bg-slate-50 transition-colors">
                    <td className="p-6 font-medium text-slate-700">
                      {item.aspect}
                    </td>
                    <td className="p-6 text-center bg-red-50/50">
                      <div className="flex items-center justify-center gap-2">
                        <X className="w-5 h-5 text-red-500 flex-shrink-0" />
                        <span className="text-slate-700">{item.diy.value}</span>
                      </div>
                    </td>
                    <td className="p-6 text-center bg-green-50/50">
                      <div className="flex items-center justify-center gap-2">
                        <Check className="w-5 h-5 text-green-500 flex-shrink-0" />
                        <span className="font-semibold text-slate-900">{item.with2besales.value}</span>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card>

        <div className="mt-12 text-center">
          <p className="text-lg text-slate-600 mb-6">
            Als <strong className="text-slate-900">Done-for-you Agentur</strong> kombinieren wir LinkedIn, 
            menschliche Expertise und AI-Technologie – für <strong className="text-slate-900">über 60% Rückmelderate</strong> 
            bei minimalem Zeitaufwand für dich.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ComparisonTable;
